import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PasswordManager from "./components/PasswordManager";

import './styles/index.scss';
import './index.css';
import 'font-awesome/scss/font-awesome.scss';

class Dashboard extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<PasswordManager></PasswordManager>
			</div>
		);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	ReactDOM.render(
		<Dashboard></Dashboard>,
		document.getElementById('ppw-master-passwords'));
});



// WEBPACK FOOTER //
// ./index.js